export default "__VITE_ASSET__DVY9SAP0__"